// src/components/common/table/tableStyles.ts

import type { SxItem } from './sx';

export const standardTableContainerSx: SxItem = (theme) => ({
  borderRadius: 2,
  border: `1px solid ${theme.palette.divider}`,
  overflowX: 'auto',
});

export const standardTableHeadSx: SxItem = (theme) => ({
  '& .MuiTableCell-head': {
    backgroundColor:
      theme.palette.mode === 'light'
        ? theme.palette.grey[900]
        : theme.palette.grey[800],
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    whiteSpace: 'nowrap',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
});

/**
 * Small reusable cell styles.
 * NOTE:
 * - Keep them plain objects so they can be spread into `sx={...}` safely.
 * - Use `as const` to preserve literal typing and reduce accidental mutation.
 */
export const cellSx = {
  nowrap: { whiteSpace: 'nowrap' } as const,

  mono: {
    whiteSpace: 'nowrap',
    fontFamily:
      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    fontSize: 13,
  } as const,

  money: {
    whiteSpace: 'nowrap',
    fontFamily:
      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    fontVariantNumeric: 'tabular-nums',
    fontSize: 13,
  } as const,

  number: {
    whiteSpace: 'nowrap',
    fontVariantNumeric: 'tabular-nums',
  } as const,
} as const;
